export enum ProjectType {
  Restricted = 1, // Invite only and hidden to anyone who is not invited
  Invite = 2, // Invite only but viewable by all users in the same client (DEFAULT)
  Organisation = 3, // All users in the client have access
  Showcase = 99, // Everyone in every organisation can view (internal clients only)
}

export const ProjectTypeMetadata: {
  [key in ProjectType]: { label: string; badgeClass: string; icon: string };
} = {
  [ProjectType.Restricted]: {
    label: 'Restricted',
    badgeClass: 'text-bg-danger',
    icon: 'bi-lock-fill',
  },
  [ProjectType.Invite]: {
    label: 'Invite',
    badgeClass: 'text-bg-warning',
    icon: 'bi-person-plus-fill',
  },
  [ProjectType.Organisation]: {
    label: 'Organisation',
    badgeClass: 'text-bg-primary',
    icon: 'bi-building',
  },
  [ProjectType.Showcase]: {
    label: 'Showcase',
    badgeClass: 'text-bg-info',
    icon: 'bi-globe',
  },
};
